<mat-progress-bar *ngIf="loading" mode="indeterminate" />
<mat-card class="cardWithShadow">

    <!-- Skeleton -->
    <div *ngIf="loading" class="p-32">
        <ngx-skeleton-loader count="5" [theme]="{height: '30px'}" />
    </div>

    <mat-card-content *ngIf="!loading" class="p-y-32">
        <form [formGroup]="form">
            <div class="col-lg-12 p-x-0 d-flex gap-10">
                <!-- Name -->
                <ng-container>
                    <mat-form-field class="w-50" appearance="outline">
                        <mat-label>Nome</mat-label>
                        <input matInput formControlName="name" placeholder="Nome utente">
                    </mat-form-field>
                </ng-container>

                <!-- Email -->
                <ng-container>
                    <mat-form-field class="w-50" appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" placeholder="Email" [readonly]="type === 'edit'">
                    </mat-form-field>
                </ng-container>
            </div>
            <ng-container *ngIf="type === 'add'">
                <div class="col-lg-12 p-x-0 d-flex text-center">
                    <!-- Livello utente -->
                    <mat-radio-group aria-label="Livello utente" formControlName="level" class="m-x-auto">
                        <mat-label>Livello utente</mat-label><BR>
                        <mat-radio-button value='site' [checked]="userType === 'Sito'">Site</mat-radio-button>
                        <mat-radio-button value='cer' [checked]="userType === 'Cer'">Cer</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="col-lg-12 m-t-20 p-x-0 d-flex gap-10 text-center">
                    <!-- Sito di appartenenza -->
                    <div style="width: 50%; margin: 0 auto;" *ngIf="f['level'].value === 'site'">
                        <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Sito di
                            appartenenza*</mat-label>
                        <mat-form-field appearance="outline" class="w-100" color="primary">
                            <mat-label>Sito di appartenenza</mat-label>
                            <mat-select matInput formControlName="site">
                                <mat-option *ngFor="let site of siteList" [value]="site.id">
                                    {{ site.description }}
                                </mat-option>
                            </mat-select>
                            <mat-hint *ngIf="f['site'].touched && f['site'].invalid" class="m-b-16 error-msg">
                                <div class="text-error" *ngIf="f['site'].errors && f['site'].errors['required']">
                                    Campo obbligatorio
                                </div>
                            </mat-hint>
                        </mat-form-field>
                    </div>

                    <!-- Cer -->
                    <div style="width: 50%; margin: 0 auto;" *ngIf="f['level'].value === 'cer'">
                        <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Cer di appartenenza*</mat-label>
                        <mat-form-field appearance="outline" class="w-100" color="primary">
                            <mat-label>CER di appartenenza</mat-label>
                            <mat-select matInput formControlName="cer">
                                <mat-option *ngFor="let option of cerList" [value]="option.id">
                                    {{ option.description }}
                                </mat-option>
                            </mat-select>
                            <mat-hint *ngIf="f['cer'].touched && f['cer'].invalid" class="m-b-16 error-msg">
                                <div class="text-error" *ngIf="f['cer'].errors && f['cer'].errors['required']">
                                    Campo obbligatorio
                                </div>
                            </mat-hint>
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>
            <div class="col-lg-12 p-x-0 d-flex gap-10 text-center">
                <button mat-flat-button class="w-15 m-x-auto " color="primary" *ngIf="type === 'add'"
                    (click)="onSubmit()"
                    [disabled]="form.invalid || (!f['cer'].value && !f['site'].value && f['level'].value !== 'admin')">Salva</button>
                <button mat-flat-button class="w-15 m-x-auto " color="primary" *ngIf="type === 'edit'"
                    (click)="onSubmit()" [disabled]="form.invalid">Salva</button>
            </div>
        </form>
    </mat-card-content>
</mat-card>